import React from 'react'
import HTML from '../components/HTML'
import useSettingsV2 from '../hooks/useSettingsV2'

const styles = { vimeo: { width: '100%', height: '500px' } }

function Replay() {
  const { settings } = useSettingsV2()

  return (
    <>
      <HTML name="replayHtml" />
      {settings?.replayVimeoUrl && (
        <iframe
          style={styles.vimeo}
          title="Replay"
          src={settings.replayVimeoUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </>
  )
}

export default Replay
